export const geoCode = async (address: string): Promise <{
    lat: number;
    lon: number;
}> => {
  
    const geoCode = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`);
    const response = await geoCode.json();
    const lat = parseFloat(response[0].lat)
    const lon = parseFloat(response[0].lon)

    return {lat, lon}

}